export class BocciaturaConsegnaFase2 {
    

    verbaleOK!:boolean;
    allegatiOK!:boolean;

    noteVerbale!:string;
    noteAllegati!:string;


    problemiVerbale!:string[];
    problemiAllegati!:string[];
    
  }
  